import types from './types'
import axios from 'axios'

export default {
  namespaced: true,
  state: {
    status: void 0,
    questionnaire: {},
    teamId: {},
    team: {},
    user: {},
    items: [],
    total: 0
  },
  actions: {
    async getList ({ commit }, { questionnaireId, teamId, page = 1, perPage = undefined, sf, so, months }){
      commit(types.GET_USERS.REQUEST, { questionnaireId, teamId, page, perPage, sf, so })
      try {
        commit(types.GET_USERS.SUCCESS, await axios.get(`/api/waveline/questionnaires/${questionnaireId}/team/${teamId}/user`, { params: { l: perPage, lo: page - 1, sf, so, months } }))
      } catch (err) {
        commit(types.GET_USERS.FAILURE)
      } finally {
      }
    }
  },
  mutations: {
    [types.GET_USERS.REQUEST] (state, params) {
      state.status = 'fetching'
      if ((state.questionnaire !== params.questionnaireId) && (state.teamId !== params.teamId)){
        state.items = []
      }
      state.questionnaire = params.questionnaireId
      state.teamId = params.teamId
    },
    [types.GET_USERS.SUCCESS] (state, result) {
      state.status = 'success'
      state.items = result.data.items
      state.total = result.data.total
      state.team = result.data.team
    },
    [types.GET_USERS.FAILURE] (state) {
      state.status = 'error'
    }
  },
  getters: {
    getUsers: state => (questionnaireId, teamId) => {
      if ( (state.questionnaire === questionnaireId) && (state.teamId === teamId) ){
        return state.items
      }
      return null
    }
  }
}
